import { render, staticRenderFns } from "./ContactDetails.vue?vue&type=template&id=7eb95b78&scoped=true&"
import script from "./ContactDetails.vue?vue&type=script&lang=js&"
export * from "./ContactDetails.vue?vue&type=script&lang=js&"
import style0 from "./ContactDetails.vue?vue&type=style&index=0&id=7eb95b78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eb95b78",
  null
  
)

export default component.exports